import React , { useContext, useEffect }from "react";
import { UserContext, Axios } from './UserContext';
import { db } from "./Db";
import { getMessagingInstance, getToken } from "../firebaseConfig";

export default function Main(){

    // --- Użytkownik i wylogowanie ---

    const {user} = useContext(UserContext);

    const {logout} = useContext(UserContext);

    useEffect(() => {

        if(Notification.permission === "granted"){

            db.token.toArray().then(function(result){

                if(result.length > 0){

                    const saved = result[0].saved;

                    if(!saved){

                        saveToken(true);

                    }

                } else {

                    saveToken(true);

                }

            });

        } 

        // eslint-disable-next-line
    }, []);

    async function saveToken(ask){

        const permission = ask ? "granted" : await Notification.requestPermission();

        const messaging = await getMessagingInstance();

        if(!messaging) return;

        if(permission === "granted"){

                getToken(messaging, {

                vapidKey: process.env.REACT_APP_VAPID_KEY,

            }).then((currentToken) => {

                if(currentToken){

                    let request_type = 'save token';

                    let user_id = user.user_id;

                    let firebase_token = currentToken;

                    Axios.post('classes/notifications.php', { request_type, user_id, firebase_token }, { timeout: 5000 }).then(function(response){

                        if(response.data.success){

                            db.token.put({index: 1, saved: true});

                        } else {

                            db.token.put({index: 1, saved: false});

                        }

                    }).catch((error) => {

                        db.token.put({index: 1, saved: false});

                        console.warn(error);

                    });

                } else {

                    db.token.put({index: 1, saved: false});

                    console.log("No FCM token available");

                }

            }).catch((err) => console.error("Error getting token", err));

        }

    }

    return (
        <div id="app-outer-container">
            <div id="app-inner-container">
                <div id="test-container">
                    <p id="test-info">Zalogowano!</p>
                    <button className="test-button" onClick={() => saveToken(false)}>Powiadomienia</button>
                    <button className="test-button" onClick={logout}>Wyloguj się</button>
                </div>
            </div>
        </div>
    );
};